
import filters from "@/filters";
import { Component, Vue } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import ImageCropper from "@/components/ImageCropper.vue";
import { Action, State } from "vuex-class";
import { AxiosResponse } from "axios";
import { isEmail, isPhone } from "@/functions/global.function";

@Component({
  components: {
    AppLayout,
    ImageCropper,
  },
  filters,
})
export default class Profile extends Vue {
  @Action("getSelf", { namespace: "auth" })
  private getSelf: any;
  @Action("editProfile", { namespace: "auth" })
  private editProfile: any;

  @State("user", { namespace: "auth" })
  private user!: any;

  private isLoading = true;
  private isEdit = false;
  private name = "";
  private email = "";
  private phone = "";
  private nameError = "";
  private emailError = "";
  private phoneError = "";
  private image = "";
  private imageFile: File | null = null;
  private showCropper = false;
  private disableSubmitButton = false;

  private get canEdit() {
    return !this.user?.partner_id && !this.isEdit;
  }

  private setEdit() {
    this.name = this.user?.name;
    this.email = this.user?.email;
    this.phone = this.user?.phone;
    this.image = this.user?.image;
    this.imageFile = null;
    this.isEdit = true;
  }

  private onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode !== 43) {
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    }
  }

  private resetError() {
    this.nameError = "";
    this.emailError = "";
    this.phoneError = "";
  }

  private submit() {
    this.disableSubmitButton = true;
    this.resetError();
    if (!this.name) {
      this.nameError = "The name field is required.";
      return false;
    }
    if (!this.email) {
      this.emailError = "The email field is required.";
      return false;
    }
    if (!isEmail(this.email)) {
      this.emailError = "The email field must be a valid email address.";
      return false;
    }
    if (!this.phone) {
      this.phoneError = "The phone field is required.";
      return false;
    }
    if (
      (this.phone.startsWith("+62") && (this.phone.length < 10 || this.phone.length > 15)) ||
      (this.phone.startsWith("0") && (this.phone.length < 9 || this.phone.length > 13))
    ) {
      this.phoneError = "The phone field must be between 9 and 13 digits.";
      return false;
    }
    if (!isPhone(this.phone)) {
      this.phoneError =
        "The phone field must be a valid phone number. (e.g. +62812345678890)";
      return false;
    }

    const formData = new FormData();
    formData.append("name", this.name);
    formData.append("email", this.email);
    formData.append("phone", this.phone);
    if (this.imageFile) {
      formData.append("image", this.imageFile);
    }

    this.editProfile({
      params: formData,
      success: (response: AxiosResponse) => {
        this.isEdit = false;
        this.isLoading = true;
        this.getSelf({
          success: () => {
            this.image = this.user?.image || "";
          },
          finally: () => {
            this.isLoading = false;
          },
        });
      },
      finally: () => {
        this.disableSubmitButton = false;
      },
    });
  }

  private onCropChange(file: File) {
    this.imageFile = file;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.image = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  private mounted() {
    this.getSelf({
      success: () => {
        this.image = this.user?.image || "";
      },
      finally: () => {
        this.isLoading = false;
      },
    });
  }
}
